var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.current,"page-size":_vm.pageSize,"layout":"prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.current=$event},"update:current-page":function($event){_vm.current=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }